import React, {useState,useEffect} from 'react';
import {Redirect,Link} from 'react-router-dom'//yarn add @types/react-router-dom
import useStyles from './Styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import Checkbox from '@mui/material/Checkbox';
//import Divider from '@mui/material/Divider';
import Hidden from '@mui/material/Hidden';
import StoreImg from './StoreImg';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import {Owner,Secret,Item,OverrideEvent} from './Inc';
import Toast from './Toast';
import RowData from './RowData';
import Ajax from './Ajax';
import Loading from './Loading';
import SecretConfirm from './SecretConfirm';
import OverrideInput from './OverrideInput';
import Title from './Title';
import {Tools} from './Tools';

interface Props {
    owner:Owner,
    managerId:number,
}

const OverrideItems = (props:Props)=> {
    Ajax.setEditorId( props.owner.owner_id );
    const classes = useStyles();
    const defItems:Item[] = [];
    const [states,setStates] = useState({
        items: defItems,
        selectedItemId: 0,
        itemIds: [] as number[],
        filtered: "0",
        ready: false,
        redirectId: 0,
        isLoading: true,
        isConfirm: false,
		currentPage:1,
        currentEvent: {} as OverrideEvent,
        pager:null,
    });
    const [toast,setToast] = useState("");

    const toggleFiltered = ()=>{
        const filtered = states.filtered==="1" ? "0" : "1";
        search(1,filtered);
    }

    const search = (page:number,filtered:string)=>{
        setStates({...states,"isLoading":true,filtered:filtered});
        window.scrollTo(0,0);
        Ajax.search("override/items",{"filtered":filtered},page,(res:any)=>{
            if( res.ok ){
                setStates({...states,
                    "isLoading":false,
                    filtered:filtered,
                    "items":res.items,
                    "itemIds":res.item_ids,
                    currentEvent:res.event as OverrideEvent,
                    currentPage:page,
                    pager:res.pager
                });
            }
        });
    }

	const jump = (newPage:number)=>{
		search(newPage,states.filtered);
    }

    const openInput = (item_id:number)=>{
        //console.log("openInput",item_id);
        setStates({...states,"selectedItemId":item_id});
    }

    const closeInput = (updated:boolean)=>{
        if( updated ){
            setStates({...states,"selectedItemId":0,"redirectId":1});
        } else {
            setStates({...states,"selectedItemId":0});
        }
    }

	const ItemRow = (props:{item:Item,owner_id:number,index:number})=>{
		let num_stock = 0;
		if( props.item.num_stock ){
			num_stock = props.item.num_stock;
		}
		return (
			<TableRow>
				<Hidden smDown implementation="js">
					<TableCell className={classes.tableCellDense} align="center" style={{width:'5em'}}>
						<StoreImg owner_id={props.owner_id} img_id={props.item.img_id} thumb={true} className="imgList"/>
					</TableCell>
				</Hidden>
				<TableCell className={classes.tableCellDense}>
					<span className={classes.itemId}>ID:{props.item.item_id}</span>　
					<Hidden smUp implementation="js">
						<br/>
					</Hidden>
					{props.item.item_name}<br/>
					{props.item.page_name!==null && props.item.page_name !== "" ? (
					<div className="with_page_name">{props.item.page_name}</div>
					):(
					<div className="with_page_name">　</div>
					)}
				</TableCell>
				<TableCell sx={{paddingRight:{sm:'1rem',md:'0.5rem'}}} align="right">{num_stock}</TableCell>
				<Hidden smDown implementation="js">
					<TableCell className={classes.tableCellNowrap} align="center" style={{width:'6em'}}>
						{Tools.colorLabel("item_status",props.item.status,props.item.status_label)}<br/>
					</TableCell>
				</Hidden>
				<TableCell sx={{width:{sm:'5rem',md:'5.5rem'},padding:'0',textAlign:'center'}}>
                    {states.itemIds.includes(props.item.item_id) ? (
                    <span style={{color:'gray'}}>登録済</span>
                    ):(
                    <Button variant="contained" color="primary" size="small" onClick={()=>openInput(props.item.item_id)} style={{margin:'0'}}>選択</Button>
                    )}
				</TableCell>
			</TableRow>
		);
	};


    useEffect( ()=>{
        if( props.owner.owner_id>0 ){
            search(1,"0");
        } else {
            setStates({...states,"isLoading":false});
        }
    } ,[]);

	if( props.owner.owner_id===0 ){
		return <Redirect to="/profile"/>
	}
	
    if( states.redirectId>0 ){
        return (
            <Redirect to="/override"/>
        )
    }

	return (
		<div id="profile_input" className={classes.root}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={9}>
                    <Paper className={classes.paper}>
                        <Title text="オーバーライドを登録" icon="trending"/>
                        <div style={{marginBottom:"2em"}}>
                        オーバーライドを登録する商品を選択して下さい。<br/>
                        </div>
                        <Box sx={{marginBottom:"2rem",display:"flex",justifyContent:{xs:"space-between",md:"flex-end"}}}>
                            <label style={{cursor:"pointer"}}>
                                <Checkbox
                                    checked={states.filtered==="1"}
                                    onChange={toggleFiltered}
                                    value={"1"}
                                    color="primary"
                                    className={classes.listCheckbox}
                                />未登録の商品だけ
                            </label>
                            <Box sx={{display: { xs: 'block', md: 'none' }}}>
                                <Link to="/override"><Button variant="outlined">やめる</Button></Link>
                            </Box>
                        </Box>
                        {states.items.length===0 ? (
                            <div style={{textAlign:"center",margin:"2rem 0",padding:"2rem 0",border:"1px solid #ddd"}}>
                                <div style={{fontSize:"1.0rem",color:"#ccc"}}>登録可能な商品はありません。</div>
                            </div>
                        ):(
                        <Table id="item_check_table">
                            <TableHead>
                                <TableRow>
                                    <Hidden smDown implementation="js">
                                        <TableCell className={classes.tableHeadNowrap} align="center">画像</TableCell>
                                    </Hidden>
                                    <TableCell className={classes.tableHeadNowrap} align="center">商品</TableCell>
                                    <TableCell className={classes.tableHeadNowrap} align="center">在庫</TableCell>
                                    <Hidden smDown implementation="js">
                                    <TableCell className={classes.tableHeadNowrap} align="center">状態表示</TableCell>
                                    </Hidden>
                                    <TableCell className={classes.tableHeadNowrap} align="center">選択</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {states.items.map( (item:Item,index:number)=>{
                                    const key = "item"+index;
                                    return <ItemRow item={item} owner_id={props.owner.owner_id} index={index} key={key}/>
                                })}
                            </TableBody>
                        </Table>
                        )}
                        <div style={{padding:"1em"}}>
                        {Tools.pager(states.pager,jump)}
                        </div>
                    </Paper>
                </Grid>
                <Grid item xs={12} md={3}>
                    <Paper className={classes.paper}>
                        <Title text="管理情報" size={2}/>
                        <RowData name="対象イベント" value={states.currentEvent?.name} width="60%"/>
                        <RowData name="開催期間" value={`${states.currentEvent?.start} - ${states.currentEvent?.end}`} width="60%"/>

                        <Hidden smDown implementation="js">
                            <Divider style={{margin:"1em 0"}}/>
                            <Button variant="outlined" component={Link} to="/override" style={{width:"100%"}}>やめる</Button>
                        </Hidden>
                    </Paper>
                </Grid>
            </Grid>
            <OverrideInput itemId={states.selectedItemId} event={states.currentEvent} isOpen={states.selectedItemId>0} owner={props.owner} managerId={props.managerId} close={closeInput}/>
		</div>
	);
}

export default OverrideItems;
